export default {
  apiBaseUrl: window.location.origin + '/api/'
}
